import cn from 'classnames';

import type { ReactElement } from 'react';

interface SliderTickmarksProps {
  isActiveLayer: boolean;
  tickmarkMeta: Array<{ isMajor: boolean; percent: number }>;
}

/*
 * Renders a row of decorative tick dots along the slider rail.
 * Two instances of this component are rendered: one for the inactive (rail) layer
 * and one for the active (track) layer, clipped via CSS `clip-path`.
 *
 * - `isActiveLayer` — when `true`, applies the active color class.
 * - `tickmarkMeta` — array of tickmark positions and major/minor classification.
 */
export const SliderTickmarks = ({ isActiveLayer, tickmarkMeta }: SliderTickmarksProps): ReactElement => {
  return (
    <span className={cn('rbui-slider__tickmarks', { 'rbui-slider__tickmarks--active': isActiveLayer })}>
      {tickmarkMeta.map(({ isMajor, percent }) => {
        return <span className={cn('rbui-slider__tick', { 'rbui-slider__tick--major': isMajor })} key={percent} />;
      })}
    </span>
  );
};

SliderTickmarks.displayName = 'SliderTickmarks';
